import React, { CSSProperties, MouseEvent } from 'react';
import styled from 'styled-components';

import { User } from '@/types/userList';
import { FormValues } from '@/components/pages/Users/Index/UserListForm';
import { UserFormContents } from './UserFormContents';

type Props = {
  isUpdating: boolean;
  onCancelClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  onSubmit: (values: FormValues) => Promise<void>;
  recomputeRowHeights: () => void;
  style: CSSProperties;
  user: User;
};

export const UserForm: React.FC<Props> = ({
  isUpdating,
  onCancelClick,
  onSubmit,
  recomputeRowHeights,
  style,
  user,
}) => {
  return (
    <Wrapper style={style}>
      <UserFormContents
        isUpdating={isUpdating}
        onCancelClick={onCancelClick}
        onSubmit={onSubmit}
        recomputeRowHeights={recomputeRowHeights}
        user={user}
        style={style}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border: 1px solid #d4d4d5;
  min-height: 65px;
  padding: 24px;
  width: 100%;
  border-top-width: 0;
`;
